import { APP_VERSION, APP_VERSION_TIMESTAMP } from '@app/data/version';
import {
  APP_VERSION_STORAGE_KEY,
  APP_VERSION_TIMESTAMP_STORAGE_KEY,
  LATEST_FRONTEND_VERSION_TIMESTAMP_STORAGE_KEY,
  RELOADED_FRONTEND_VERSION_TIMESTAMP_STORAGE_KEY,
  toUnixSeconds,
} from '@app/shared/utils';

export const checkAppVersionAndClearSessionStorage = () => {
  const currentVersion = APP_VERSION;
  const currentVersionTimestamp = String(APP_VERSION_TIMESTAMP);

  const storedVersionTimestamp = sessionStorage.getItem(
    APP_VERSION_TIMESTAMP_STORAGE_KEY
  );

  if (!storedVersionTimestamp) {
    sessionStorage.setItem(
      APP_VERSION_TIMESTAMP_STORAGE_KEY,
      currentVersionTimestamp
    );
    sessionStorage.setItem(APP_VERSION_STORAGE_KEY, currentVersion);
    return;
  }

  if (!APP_VERSION_TIMESTAMP) return;

  const storedVersionUnixSeconds = toUnixSeconds(storedVersionTimestamp);

  if (storedVersionUnixSeconds !== APP_VERSION_TIMESTAMP) {
    sessionStorage.clear();
    sessionStorage.setItem(
      APP_VERSION_TIMESTAMP_STORAGE_KEY,
      currentVersionTimestamp
    );
    sessionStorage.setItem(APP_VERSION_STORAGE_KEY, currentVersion);
    return;
  }

  sessionStorage.setItem(APP_VERSION_STORAGE_KEY, currentVersion);

  const latestVersionTimestamp = toUnixSeconds(
    sessionStorage.getItem(LATEST_FRONTEND_VERSION_TIMESTAMP_STORAGE_KEY)
  );

  if (
    !latestVersionTimestamp ||
    latestVersionTimestamp <= APP_VERSION_TIMESTAMP
  ) {
    sessionStorage.removeItem(LATEST_FRONTEND_VERSION_TIMESTAMP_STORAGE_KEY);
    sessionStorage.removeItem(RELOADED_FRONTEND_VERSION_TIMESTAMP_STORAGE_KEY);
  }
};
